import React from 'react';
import classNames from 'classnames';

import MultiSelect, { MultiSelectOption } from '../../../components/multi-select/multi-select';
import { Button, Tooltip } from '../../../components';
import { getConditionTestId, trashIcon, Condition } from '../rule/rule-utils';
import IndexedLabel from '../../../components/indexed-label/indexed-label';
import AttributePath from '../rule/components/attribute-path';

import '../conditions.scss';

export interface MultiSelectConditionProps {
	disabled?: boolean;
	index?: number;
	maxAttributePathItems?: number;
	condition: Condition;
	placeholder?: string;
	parentContainerClass?: string;
	removeTooltipText?: string;
	options: Partial<MultiSelectOption>[];
	onChange(condition: Condition, value: string[]): void;
	onRemove(condition: Condition): void;
	withIndexedLabel?: boolean;
}

export const INPUT_WIDTH = 290;

const MultiSelectCondition: React.FC<MultiSelectConditionProps> = ({
	index,
	condition,
	options,
	placeholder,
	parentContainerClass,
	withIndexedLabel = true,
	onChange,
	onRemove,
	maxAttributePathItems,
	removeTooltipText,
	disabled = false
}: MultiSelectConditionProps) => {
	const { name, value } = condition;
	const otherProps = {};
	if (parentContainerClass) {
		otherProps['getPopupContainer'] = () => document.querySelector(`.${parentContainerClass}`);
	}

	const testId = getConditionTestId(name);

	return (
		<div className={classNames('condition-container', { 'disabled-condition': disabled })} data-test-id={testId}>
			{index && withIndexedLabel && <IndexedLabel index={index} />}
			<div id={!withIndexedLabel ? 'short-name' : undefined} className="name">
				<AttributePath path={name} maxPathItems={maxAttributePathItems} />
			</div>
			<MultiSelect
				disabled={disabled}
				data-test-id={`${testId}_select`}
				showArrow
				className={classNames('default-multiselect', { 'wide-multiselect': !withIndexedLabel })}
				placeholder={placeholder}
				options={options}
				value={value}
				allowClear
				byKey
				onChange={values => onChange(condition, values)}
				{...otherProps}
			/>
			<Tooltip placement="top" title={removeTooltipText}>
				<Button shape="circle" className="remove-button" icon={trashIcon} onClick={() => onRemove(condition)} />
			</Tooltip>
		</div>
	);
};

export default MultiSelectCondition;
